import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    Box,
    CircularProgress
} from '@mui/material';

function ProtectedRoute({ children, allowedRoles }) {
    const { isAuthenticated, user, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        // Show a loading indicator while checking auth status
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated) {
        console.warn('[ProtectedRoute] Not authenticated, redirecting to /login', {
            path: location.pathname,
            allowedRoles
        });
        // Redirect to login page, saving the current location to redirect back after login
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check roles if provided
    if (allowedRoles && user && !allowedRoles.includes(user.role)) {
        console.warn('[ProtectedRoute] Role denied', {
            path: location.pathname,
            userRole: user.role,
            allowedRoles
        });
        // Redirect to an unauthorized page or back to dashboard
        // For simplicity, redirecting to dashboard for now
        // You could create a dedicated "Unauthorized" page
        console.warn(`User role (${user.role}) not in allowed roles: ${allowedRoles.join(', ')}`);
        return <Navigate to="/" replace />;
    }

    return children; // Render the protected component
}

export default ProtectedRoute; 